// Minimal className joiner — keeps components free of an external dep.
// Filters out falsy values so callers can write conditional classes inline:
//   cn("base", isActive && "active", error && "border-ember")
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
